import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axios/axios-instance";
import Card from "../../components/common/Card";
import MuiTable from "../../components/common/MuiTable";
import { Column, HTTP_METHOD_COLOR, HTTP_STATUS_CODE_COLOR } from "../../utils/constants";
import { pathAPI } from "../../utils/pathApi";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Divider, InputBase, IconButton } from "@mui/material";

const HistoryLog = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  useEffect(() => {
    getHistoryLog();
  }, []);

  const getHistoryLog = async() => {
    setLoadingTable(true);
    await axiosInstance
      .get(pathAPI.history)
      .then((response: any) => {
        if (response.data) {
          setData(response.data.data);
        }
        setLoadingTable(false);
      })
      .catch((error: any) => {
        console.log("==== get category error: ", error);
        setLoadingTable(false);
      });
  }

  const filteredData = data.filter((item: any) => {
    if (!searchKeyword.trim()) return true;
    const keyword = searchKeyword.toLowerCase();
    return (
      item.user?.toLowerCase().includes(keyword) ||
      item.ip?.toLowerCase().includes(keyword) ||
      item.request_uri?.toLowerCase().includes(keyword) ||
      item.query_string?.toLowerCase().includes(keyword) ||
      item.http_method?.toLowerCase().includes(keyword)
    );
  });

   const header: Column[] = [
      {
        id: "id",
        label: `${t("common.table.id")}`,
        minWidth: 10,
        align: "center",
      },
      {
        id: "created_date",
        label: `${t("common.table.time")}`,
        minWidth: 150,
        align: "center",
        format: (value) => {
          return <div>{moment(value).format("YYYY/MM/DD HH:mm:ss")}</div>;
        },
      },
      {
        id: "user",
        label: `${t("common.table.user")}`,
        minWidth: 170,
        align: "center",
      },
      {
        id: "ip",
        label: `${t("common.table.ip")}`,
        minWidth: 30,
        align: "center",
      },
      {
        id: "http_method",
        label: `${t("common.table.method")}`,
        minWidth: 20,
        align: "center",
        format: (value) => {
          type HttpMethod = keyof typeof HTTP_METHOD_COLOR;
          const normalizedValue = value.toUpperCase() as HttpMethod;
          return <div className={`px-2 rounded-md font-bold ${HTTP_METHOD_COLOR[normalizedValue]?.color || 'bg-gray-400'}`}>{value}</div>;
        }
      },
      {
        id: "request_uri",
        label: `${t("common.table.request_uri")}`,
        minWidth: 100,
        align: "center",
      },
      {
        id: "status_code",
        label: `${t("common.table.status_code")}`,
        minWidth: 10,
        align: "center",
        format: (value) => {
          type HttpStatusCode = keyof typeof HTTP_STATUS_CODE_COLOR;
          const normalizedValue = value as HttpStatusCode;
          return <div className={`px-2 rounded-md font-bold ${HTTP_STATUS_CODE_COLOR[normalizedValue]?.color || 'bg-gray-400'}`}>{value}</div>;
        }
      },
      {
        id: "query_string",
        label: `${t("common.table.query")}`,
        minWidth: 120,
        align: "center",
      },
    ];
  return (
    <Card>
      <Box sx={{ display: "flex", alignItems: "center", border: "1px solid var(--app-border)", borderRadius: 2, mb: 2, p: 0.5 }}>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder={t("history_log.search_placeholder")}
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
        />
        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        <IconButton type="button" sx={{ p: "10px" }} aria-label={t("history_log.search_aria")}>
          <SearchIcon />
        </IconButton>
      </Box>
      <MuiTable header={header} data={filteredData} isLoading={loadingTable}></MuiTable>
    </Card>
  );
};
export default HistoryLog;
